import { useSelector } from "react-redux";

import { selectErrors } from "../../app/slices/ValidationSlice";

export default function useErrorValidation() {
  const allErrors = useSelector(selectErrors);

  const getErrorsForInteraction = (interactionId: string) => {
    return allErrors[interactionId] ?? [];
  };

  return { getErrorsForInteraction } as const;
}
